import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import PublicLayout from "@/components/layout/PublicLayout";
import StudentLayout from "@/components/layout/StudentLayout";
import AdminLayout from "@/components/layout/AdminLayout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Course from "@/pages/Course";
import CalendarPage from "@/pages/CalendarPage";
import Locations from "@/pages/Locations";
import FAQPage from "@/pages/FAQPage";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Checkout from "@/pages/Checkout";

import StudentDashboard from "@/pages/student/Dashboard";
import StudentProfile from "@/pages/student/Profile";
import OnlineEnrolmentNew from "@/pages/student/OnlineEnrolmentNew";
import MyCourses from "@/pages/student/MyCourses";
import StudentBookings from "@/pages/student/Bookings";
import StudentEnrolments from "@/pages/student/Enrolments";
import StudentPayments from "@/pages/student/Payments";
import StudentCertificates from "@/pages/student/Certificates";
import StudentDocuments from "@/pages/student/Documents";
import StudentNotifications from "@/pages/student/Notifications";
import Support from "@/pages/student/Support";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminStudents from "@/pages/admin/AdminStudents";
import AdminCourses from "@/pages/admin/AdminCourses";
import AdminClasses from "@/pages/admin/AdminClasses";
import AdminTrainers from "@/pages/admin/AdminTrainers";
import AdminEnrolments from "@/pages/admin/AdminEnrolments";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminCertificates from "@/pages/admin/AdminCertificates";
import AdminAttendance from "@/pages/admin/AdminAttendance";
import AdminReports from "@/pages/admin/AdminReports";
import AdminNotifications from "@/pages/admin/AdminNotifications";
import AdminSupport from "@/pages/admin/AdminSupport";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          {/* Public site */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/course" element={<Course />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/checkout/:classId?" element={<Checkout />} />
            <Route path="/admin/login" element={<AdminLogin />} />
          </Route>

          {/* Student portal */}
          <Route path="/student" element={<StudentLayout />}>
            <Route index element={<Navigate to="/student/dashboard" replace />} />
            <Route path="dashboard" element={<StudentDashboard />} />
            <Route path="profile" element={<StudentProfile />} />
            <Route path="enrol-new" element={<OnlineEnrolmentNew />} />
            <Route path="my-courses" element={<MyCourses />} />
            <Route path="bookings" element={<StudentBookings />} />
            <Route path="enrolments" element={<StudentEnrolments />} />
            <Route path="payments" element={<StudentPayments />} />
            <Route path="certificates" element={<StudentCertificates />} />
            <Route path="documents" element={<StudentDocuments />} />
            <Route path="notifications" element={<StudentNotifications />} />
            <Route path="support" element={<Support />} />
          </Route>

          {/* Admin portal */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="students" element={<AdminStudents />} />
            <Route path="courses" element={<AdminCourses />} />
            <Route path="classes" element={<AdminClasses />} />
            <Route path="trainers" element={<AdminTrainers />} />
            <Route path="enrolments" element={<AdminEnrolments />} />
            <Route path="payments" element={<AdminPayments />} />
            <Route path="certificates" element={<AdminCertificates />} />
            <Route path="attendance" element={<AdminAttendance />} />
            <Route path="support" element={<AdminSupport />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="notifications" element={<AdminNotifications />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
